import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

function AdminPrivateRoute({ children, requireSuperAdmin = false }) {
    const { isAuthenticated, loading, isSuperAdmin } = useAdminAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="admin-loading">
                <div className="admin-loading-spinner"></div>
                <p>Chargement...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    if (requireSuperAdmin && !isSuperAdmin()) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return children;
}

export default AdminPrivateRoute;
